import styled from "styled-components";
import { LoginCardContent } from "../home/home.styles";
import { Button as AntdButton } from "antd";
export const PageWrapper = styled.div `
  background: #f6f8fa;
  min-height: 100vh;
  padding: 32px 0;
`;
export const HeaderRow = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1300px;
  margin: 0 auto 32px auto;
  padding: 0 24px;
`;
export const Title = styled.h2 `
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
`;
export const AddButton = styled(AntdButton) `
  background: #059669;
  color: #fff;
  font-weight: 600;
  border-radius: 8px;
  height: 40px;
  &:hover {
    background: #047857;
    color: #fff;
  }
`;
export const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 20px;
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 24px;
`;
export const LoginCardGridItem = styled(LoginCardContent) `
  display: flex;
  align-items: flex-start;
  gap: 22px;
  padding: 32px;
  min-height: 100px;
  border: 1px solid #f3f4f6;
  box-shadow: 0 4px 24px 0 rgba(80, 120, 200, 0.10);
  cursor: pointer;
  position: relative;
  transition: box-shadow 0.18s, transform 0.18s, border-color 0.18s;
  &:hover {
    box-shadow: 0 12px 36px 0 rgba(80, 120, 200, 0.16);
    transform: translateY(-3px) scale(1.018);
    border-color: #b6e4d8;
  }
  &::before {
    content: none;
  }
  > * {
    position: relative;
    z-index: 1;
  }
`;
export const InnerCardContent = styled.div `
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 22px;
  padding: 25px;
`;
export const SiteImage = styled.div `
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e0f2fe;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #059669;
  flex-shrink: 0;
  overflow: hidden;
  box-shadow: 0 2px 8px 0 rgba(80, 120, 200, 0.10);
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    display: block;
  }
`;
export const SiteCardContent = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;
export const SiteName = styled.div `
  font-size: 1.22rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SiteSubtitle = styled.div `
  font-size: 1rem;
  color: #6b7280;
  margin-bottom: 10px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const SiteDesc = styled.div `
  font-size: 1.01rem;
  color: #374151;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const PaginationWrapper = styled.div `
  display: flex;
  justify-content: center;
  margin: 40px 0 0 0;
`;
